import { Textarea } from 'braid-design-system';
import type { QuestionProps } from '../../type';
import { EXPERIMENT_TWO_TEXT_MAX_LENGTH } from '../../validation/validationRules';

export const PerksAndBenefitsDetailsQuestion = ({
  value = '',
  message = '',
  tone,
  onChange,
}: QuestionProps) => {
  return (
    <Textarea
      id="perksAndBenefitsDetails"
      label="What perks and benefits are offered to employees?"
      onChange={(event) => onChange(event.currentTarget.value)}
      value={value}
      tone={tone}
      message={message}
      reserveMessageSpace
      characterLimit={EXPERIMENT_TWO_TEXT_MAX_LENGTH}
    />
  );
};
